import React, {Context, createContext, ReactNode, useContext} from "react";
import {getIn} from "formik";

const useRequiredFields = () => {

  const {requiredFields} = useContext(RequiredFieldsContext);

  return {
    requiredFields,
  };
};

const RequiredFieldsContext: Context<{ requiredFields: { [key: string]: boolean } }> = createContext({requiredFields: undefined});

export const useValidationSchemaContext = () => {

  const {requiredFields}: any = useContext(RequiredFieldsContext);
  const IsRequired = (name: string) => {
    const isRequired = !!(requiredFields && requiredFields[name]);
    return isRequired;
  };

  return {
    IsRequired,
  };
};

export const ValidationSchemaProvider = (props: { schema: any, children: ReactNode }) => {
  const {schema, children} = props;
  const requiredFields = {} as any;
  const fields = schema.fields;
  const keys = Object.keys(fields);
  for (const key of keys) {
      const fieldValidationSchema = getIn(fields, key);
      if (fieldValidationSchema) {
        const fieldValidationSchemaDescribe = fieldValidationSchema.describe();
        const tests = fieldValidationSchemaDescribe ? fieldValidationSchemaDescribe.tests : false;
        requiredFields[key] = tests ? !!tests.find((test) => test.name === 'required') : false;
      }
  }
  return (
    <RequiredFieldsContext.Provider value={{requiredFields}}>
      {children}
    </RequiredFieldsContext.Provider>
  );
};

